import { render, staticRenderFns } from "./TasksList.vue?vue&type=template&id=434a9942&scoped=true"
import script from "./TasksList.vue?vue&type=script&lang=js"
export * from "./TasksList.vue?vue&type=script&lang=js"
import style0 from "./TasksList.vue?vue&type=style&index=0&id=434a9942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434a9942",
  null
  
)

export default component.exports